import APIClient from '@/shared/http/clients/api'

const resourceName = 'state'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)

const StateRepository = {
  GetAll,
  GetAllPaging,
  GetById
}

export default StateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/geo/state.js